/**
 * sessionStorage = last visited collection; overwrites collection part on product pages only when set.
 */
(function () {
  var STORAGE_KEY = 'last_collection';

  function getStored() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (data && typeof data.handle === 'string' && data.handle.length > 0) return data;
      return null;
    } catch (e) {
      return null;
    }
  }

  function setStored(handle, title, url, filterLabels) {
    try {
      var payload = {
        handle: String(handle),
        title: title != null ? String(title) : '',
        url: url != null ? String(url) : ''
      };
      if (filterLabels && String(filterLabels).trim().length > 0) {
        payload.filter = String(filterLabels).trim();
      }
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  var navs = document.querySelectorAll('[data-breadcrumb-app]');
  if (!navs.length) return;

  var first = navs[0];
  var pageType = first.getAttribute('data-page-type');

  if (pageType === 'collection') {
    var handle = first.getAttribute('data-collection-handle');
    var title = first.getAttribute('data-collection-title');

    function getFilterLabelsFromSearch(search) {
      if (!search || search.indexOf('filter.') === -1) return '';
      var labels = [];
      try {
        var params = new URLSearchParams(search);
        params.forEach(function (value, key) {
          if (key.indexOf('filter.') === 0 && value) {
            try {
              labels.push(decodeURIComponent(value.replace(/\+/g, ' ')));
            } catch (e) {
              labels.push(value);
            }
          }
        });
      } catch (e) {}
      return labels.join(', ');
    }

    function updateCollectionBreadcrumbFromUrl() {
      var path = window.location.pathname || '';
      var search = window.location.search || '';
      var fullUrl = window.location.origin + path + search;
      var filterLabels = getFilterLabelsFromSearch(search);

      first.setAttribute('data-collection-url', fullUrl);
      if (filterLabels) {
        first.setAttribute('data-active-filter-labels', filterLabels);
      } else {
        first.removeAttribute('data-active-filter-labels');
      }
      if (handle) setStored(handle, title, fullUrl, filterLabels);

      var filterPart = first.querySelector('[data-breadcrumb-filter-part]');
      var sep = first.querySelector('span[aria-hidden="true"]');
      var lastLink = first.querySelector('a[href*="/collections/"]');
      if (filterLabels) {
        if (filterPart) {
          filterPart.textContent = filterLabels;
        } else {
          var sepSpan = document.createElement('span');
          sepSpan.setAttribute('aria-hidden', 'true');
          sepSpan.innerHTML = '&nbsp;/&nbsp;';
          var filterSpan = document.createElement('span');
          filterSpan.setAttribute('data-breadcrumb-filter-part', '');
          filterSpan.textContent = filterLabels;
          if (lastLink && lastLink.nextSibling) {
            first.insertBefore(sepSpan, lastLink.nextSibling);
            first.insertBefore(filterSpan, sepSpan.nextSibling);
          } else {
            first.appendChild(sepSpan);
            first.appendChild(filterSpan);
          }
        }
      } else {
        if (filterPart) {
          var prev = filterPart.previousElementSibling;
          if (prev && prev.getAttribute('aria-hidden') === 'true') {
            first.removeChild(prev);
          }
          first.removeChild(filterPart);
        }
      }
    }

    updateCollectionBreadcrumbFromUrl();

    window.addEventListener('popstate', updateCollectionBreadcrumbFromUrl);
    var origPush = history.pushState;
    var origReplace = history.replaceState;
    if (origPush) {
      history.pushState = function () {
        origPush.apply(history, arguments);
        setTimeout(updateCollectionBreadcrumbFromUrl, 0);
      };
    }
    if (origReplace) {
      history.replaceState = function () {
        origReplace.apply(history, arguments);
        setTimeout(updateCollectionBreadcrumbFromUrl, 0);
      };
    }

    return;
  }

  if (pageType === 'product') {
    var stored = getStored();
    if (!stored || !stored.url) return;
    var displayTitle = stored.title || stored.handle;
    if (stored.filter && stored.filter.length > 0) {
      displayTitle = displayTitle + ' (' + stored.filter + ')';
    }
    for (var i = 0; i < navs.length; i++) {
      var part = navs[i].querySelector('[data-breadcrumb-collection-part]');
      if (!part) continue;
      part.textContent = '';
      var link = document.createElement('a');
      link.href = stored.url;
      link.textContent = displayTitle;
      part.appendChild(link);
    }
  }
})();
